<template>
  <v-list-item
    :to="isMore ? null : path"
    class="SideBar__link"
    :class="{
      'has-path': path,
      'v-list-item--active': isActive && !isMore && !isPopout,
      'SideBar__link--primary': isPrimary,
      'SideBar__link--more': isMore,
    }"
    @click="handleClick"
  >
    <v-tooltip bottom v-if="!showDrawer && !isPopout">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item-icon
          class="SideBar__icon"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            :size="isPrimary ? 26 : 22"
            :class="{ 'SideBar__icon--primary': isPrimary }"
          >
            {{ icon }}
          </v-icon>
        </v-list-item-icon>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>

    <v-list-item-icon
      v-else-if="!isPopout"
      class="SideBar__icon"
    >
      <v-icon
        :size="isPrimary ? 26 : 22"
        :class="{ 'SideBar__icon--primary': isPrimary }"
      >
        {{ icon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-content v-if="showDrawer && !isPopout">
      <v-list-item-title class="SideBar__label">
        {{ label }}
      </v-list-item-title>
    </v-list-item-content>

    <div class="d-flex justify-center" v-if="showDrawer && !isPopout">
      <slot></slot>
    </div>

    <!-- Popout item content -->
    <template v-if="isPopout">
      <v-list-item-content>
        <v-list-item-title class="SideBar__popout-label">
          {{ label }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-list-item>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: sharedGetters } = createNamespacedHelpers('shared');

export default {
  name: 'LinkItem',
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      default: null,
    },
    isPrimary: {
      type: Boolean,
      default: false,
    },
    isMore: {
      type: Boolean,
      default: false,
    },
    isPopout: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...sharedGetters({
      showDrawer: 'SHOW_DRAWER',
    }),
    isActive() {
      if (this.path === '/' && this.$route.path === '/') {
        return true;
      } else if (this.path !== '/') {
        return this.path && this.$route.path.startsWith(this.path);
      }
      return false;
    },
  },
  methods: {
    handleClick() {
      if (this.isMore) {
        // Don't navigate for the "More" button itself, just toggle the menu
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './sidebar';
</style>
